package com.neurobs.util

import com.neurobs.aws.EventBridge
import com.neurobs.errors.{Result, StringErrorReport}
import io.circe.{Decoder, Json, parser}

object JsonUtil {

  def parseJsonString(jsonString: String): Result[Json] = {
    parser.parse(jsonString) match {
      case Left(error) => Left(StringErrorReport(error.toString))
      case Right(json) => Right(json)
    }
  }

  def getKeyValue[T](json: Json, key: String)(implicit rds: Decoder[T]): Result[T] = {
    json.hcursor.downField(key).focus match {
      case None => Left(StringErrorReport(s"Could not extract key '$key' from json: ${json.toString()}"))
      case Some(jsonValue) => jsonValue.as[T] match {
        case Left(error) => Left(StringErrorReport(s"Error handling value '${jsonValue.toString()}' for key '$key': ${error.toString()}"))
        case Right(value) => Right(value)
      }
    }
  }

  def getOptionalKeyValue[T](json: Json, key: String)(implicit rds: Decoder[T]): Result[Option[T]] = {
    json.hcursor.downField(key).focus match {
      case None => Right(None)
      case Some(jsonValue) => jsonValue.as[T] match {
        case Left(error) => Left(StringErrorReport(s"Error handling value '${jsonValue.toString()}' for key '$key': ${error.toString()}"))
        case Right(value) => Right(Some(value))
      }
    }
  }
}
